/**
 * Account lifecycle status for a user.
 *
 * Mirrors the backend `userStatus` field returned by `api/user/me` and the
 * employee APIs. Values are upper-case strings exactly as the backend sends them.
 *
 * Access model:
 * - ACTIVE     → full access to every module the user's role/plan allows.
 * - INACTIVE   → account disabled; blocked from the app (contact admin).
 * - ONBOARDING → limited access: only the Profile area (Profile + Documents).
 */
export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  ONBOARDING = "ONBOARDING",
}

/** Case-insensitive comparison of a raw status value against a UserStatus. */
const matchesStatus = (value: string | null | undefined, status: UserStatus) =>
  String(value ?? "").trim().toUpperCase() === status;

export const isActiveStatus = (value?: string | null) =>
  matchesStatus(value, UserStatus.ACTIVE);

export const isInactiveStatus = (value?: string | null) =>
  matchesStatus(value, UserStatus.INACTIVE);

export const isOnboardingStatus = (value?: string | null) =>
  matchesStatus(value, UserStatus.ONBOARDING);
